import React, { useMemo } from 'react';

import { isProtectedData } from 'pages/item/v2/components/ProtectedData';
import isEmpty from 'utils/is-empty';

import Link from '../Link';
import TablePanel from '../TablePanel';

export interface CpeProps {
    cpe: string[] | undefined;
}

const Cpe: React.FC<CpeProps> = ({ cpe }) => {
    const cpeList = useMemo(
        () =>
            cpe?.map((item) => {
                const parts = item.split(':');
                const isCpe23 = parts[1] === '2.3';
                return {
                    vendor: isProtectedData(item) ? item : parts[isCpe23 ? 3 : 2] ?? '',
                    product: isProtectedData(item) ? item : parts[isCpe23 ? 4 : 3] ?? '',
                    version: isProtectedData(item) ? item : parts[isCpe23 ? 5 : 4]?.replace(/\\/g, '') ?? '',
                    cpe: item
                };
            }),
        [cpe]
    );

    if (isEmpty(cpe)) {
        return null;
    }

    return (
        <TablePanel
            data={cpeList}
            config={[
                {
                    name: 'Vendor',
                    sortField: 'vendor',
                    field({ vendor }) {
                        return <Link href={`/search?query=cpe:*${vendor}*`} label={vendor} />;
                    }
                },
                {
                    name: 'Product',
                    sortField: 'product',
                    field({ vendor, product }) {
                        return <Link href={`/search?query=cpe:*${vendor}*${product}*`} label={product} />;
                    }
                },
                {
                    name: 'Version',
                    sortField: 'version',
                    field({ vendor, product, version }) {
                        return <Link href={`/search?query=cpe:*${vendor}*${product}*${version}*`} label={version} />;
                    }
                },
                {
                    name: 'CPE',
                    sortField: 'cpe',
                    field: 'cpe'
                }
            ]}
        />
    );
};

export default Cpe;
